import { NotFound, PageContent, PageHeader } from '@/components';
import { TenantManagerResourceGuard } from '@/features/authentication/_components/TenantManagerResourceGuard';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router';
import { CreateHierarchyLabelButton } from './hierarchy-label/_components/CreateHierarchyLabelButton';
import { HierarchyLabelsDrawerStateProvider } from './hierarchy-label/_components/DrawerStateProvider';
import { HierarchyLabelsPage } from './hierarchy-label/_pages/HierarchyLabelsPage';
import { OrganizationRoutes } from './organization/OrganizationRoutes';
import { NavigationLabelButton } from './organization/_components/NavigationLabelButton';
import { RolesRoutes } from './role/RolesRoutes';
import { SnapshotsRoutes } from './snapshots/SnapshotsRoutes';
import { SnapshotDrawerStateProvider } from './snapshots/_components/upset-drawer/SnapshotDrawerStateProvider';
import { UsersRoutes } from './user/UsersRoutes';
import { UsersPage } from './user/_components/UsersPage';

export const TenantManagerRoutes = () => {
  const { t } = useTranslation();

  return (
    <Routes>
      <Route
        path="*"
        element={<NotFound showBackButton={false} height="100vh" />}
      />
      <Route
        index
        element={
          <>
            <PageHeader
              title={t('tenant-manager-root-page')}
              breadcrumbs={[{ title: t('tenant-manager-root-page') }]}
              buttons={<NavigationLabelButton />}
            />
            <PageContent>
              <UsersPage />
            </PageContent>
          </>
        }
      />
      <Route path="/users/*" element={<UsersRoutes />} />
      <Route path="/roles/*" element={<RolesRoutes />} />
      <Route path="/organizations/*" element={<OrganizationRoutes />} />
      <Route
        path="/snapshots/*"
        element={
          <SnapshotDrawerStateProvider>
            <SnapshotsRoutes />
          </SnapshotDrawerStateProvider>
        }
      />
      <Route
        path="/label"
        element={
          <HierarchyLabelsDrawerStateProvider>
            <PageHeader
              title={t('hierarchy-labels-page')}
              breadcrumbs={[
                {
                  title: t('tenant-manager-root-page'),
                  href: '/tenant-manager',
                },
                { title: t('hierarchy-labels-page') },
              ]}
              buttons={
                <TenantManagerResourceGuard onlyEdit>
                  <CreateHierarchyLabelButton />
                </TenantManagerResourceGuard>
              }
            />
            <PageContent>
              <HierarchyLabelsPage />
            </PageContent>
          </HierarchyLabelsDrawerStateProvider>
        }
      />
    </Routes>
  );
};
